<template>
  <div class="ov">
    <div id="pinglun">
      <ul>
        <li v-for="(item, index) in product" >
          <a :href="`./pinglun/${item.newsid}`" :title="item.newsname" v-if="item.newspic"><img :src="item.newspic" :alt="item.newsname" height="100" /></a>
          <h1><a :href="`./pinglun/${item.newsid}`">{{item.newsname}}</a></h1><p><a :href="`./pinglun/${item.newsid}`">{{item.newsshort}}</a></p>
			  </li>
      </ul>
    </div>
  </div>
</template>

<script>
import finder from '../mock/finder.json'

export default {
  name: 'pinglun',
  data () {
    return {
      finder
    }
  },
  computed: {
    product () {
      let product = this.finder.finder_news.reverse() || []
      return product
    }
  }
}
</script>
